import styled from '@emotion/styled';
import { colors } from 'Constants/Colors';

export const CustomDatePickerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const CustomDatePickerLabel = styled.label`
  font-size: 0.875rem;
  color: ${colors.GRAY_DARK};
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
`;
